import { faker } from '@faker-js/faker';
import { delay, http, HttpResponse } from 'msw';

export const handlers = [
  http.get(
    '*/api/js/report_types/:report_type_id/ap_invoice_transaction_general_inputs',
    async () => {
      await delay(1000);
      return new HttpResponse(
        JSON.stringify(getGetApInvoiceTransactionGeneralInputsMock()),
        {
          status: 200,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    }
  ),

  http.get('*/api/js/ap_invoice_transaction_general_inputs', async () => {
    await delay(1000);
    return new HttpResponse(
      JSON.stringify(getGetApInvoiceTransactionGeneralInputsMock()),
      {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }),

  http.post(
    '*/api/js/report_types/:report_type_id/ap_invoice_transaction_general_inputs',
    async () => {
      await delay(1000);
      return new HttpResponse(
        JSON.stringify({
          ap_invoice_transaction_general_input: {
            ...getGetApInvoiceTransactionGeneralInputsMock()
              .ap_invoice_transaction_general_inputs[0],
          },
        }),
        {
          status: 200,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    }
  ),
  http.get('*/api/js/ap_invoice_transaction_general_inputs/:id', async () => {
    await delay(1000);
    return new HttpResponse(
      JSON.stringify({
        ap_invoice_transaction_general_input: {
          ...getGetApInvoiceTransactionGeneralInputsMock()
            .ap_invoice_transaction_general_inputs[
            faker.number.int({
              min: 0,
              max:
                getGetApInvoiceTransactionGeneralInputsMock()
                  .ap_invoice_transaction_general_inputs.length - 1,
            })
          ],
          component_type: faker.helpers.arrayElement(['date']),
          date_format_type: faker.helpers.arrayElement([
            'year_month_day',
            'year_month',
          ]),
        },
      }),
      {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }),
  http.put('*/api/js/ap_invoice_transaction_general_inputs/:id', async () => {
    await delay(1000);
    return new HttpResponse(
      JSON.stringify(getGetApInvoiceTransactionGeneralInputsMock()),
      {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }),
];

const transactionGeneralInputs = [
  {
    master_field_name: 'deal_date',
    label: '取引日',
    component_type: 'date',
    ref_label: '',
    ref_link: '',
    tooltip_message: '',
  },
  {
    master_field_name: 'name',
    label: '品目',
    component_type: 'text',
    ref_label: '部門',
    ref_link: '',
    tooltip_message: '',
  },
  {
    master_field_name: 'dept',
    label: '費用負担部門',
    component_type: 'pulldown',
    ref_label: '経費科目',
    ref_link: '',
    tooltip_message: '',
  },
  {
    master_field_name: 'ex_item',
    label: '経費科目',
    component_type: 'pulldown',
    ref_label: '',
    ref_link: '',
    tooltip_message: '',
  },
  {
    master_field_name: 'unit_value',
    label: '単価',
    component_type: 'price',
    ref_label: '',
    ref_link: '',
    tooltip_message: '',
  },
  {
    master_field_name: 'quantity',
    label: '数量',
    component_type: 'alphanumeric',
    ref_label: '',
    ref_link: '',
    tooltip_message: '',
  },
  {
    master_field_name: 'total_value',
    label: '金額',
    component_type: 'price',
    ref_label: '',
    ref_link: '',
    tooltip_message: '',
  },
  {
    master_field_name: 'dr_excise',
    label: '税区分',
    component_type: 'pulldown',
    ref_label: '税区分',
    ref_link: '',
    tooltip_message: '',
  },
  {
    master_field_name: 'invoice_kind',
    label: 'インボイス経過措置',
    component_type: 'pulldown',
    ref_label: '',
    ref_link: '',
    tooltip_message: '一般権限のユーザーには表示されません',
  },
  {
    master_field_name: 'excise_value',
    label: '消費税額',
    component_type: 'price',
    ref_label: '',
    ref_link: '',
    tooltip_message: '',
  },
  {
    master_field_name: 'has_withholding_income_tax',
    label: '源泉徴収税',
    component_type: 'checkbox',
    ref_label: '',
    ref_link: '',
    tooltip_message: '支払依頼で選択する支払先の源泉徴収税設定が適用されます',
  },
  {
    master_field_name: 'withholding_income_tax_value',
    label: '消費税額額',
    component_type: 'price',
    ref_label: '',
    ref_link: '',
    tooltip_message: '支払依頼で選択する支払先の源泉徴収税設定が適用されます',
  },
  {
    master_field_name: 'memo',
    label: 'メモ',
    component_type: 'text',
    ref_label: '',
    ref_link: '',
    tooltip_message: '',
  },
  {
    master_field_name: 'project_code',
    label: 'プロジェクト',
    component_type: 'pulldown',
    ref_label: 'プロジェクト',
    ref_link: '',
    tooltip_message: '',
  },

  {
    master_field_name: 'cr_item',
    label: '貸方科目',
    component_type: 'pulldown',
    ref_label: '',
    ref_link: '',
    tooltip_message: '',
  },
  {
    master_field_name: 'cr_sub_item',
    label: '貸方補助科目',
    component_type: 'pulldown',
    ref_label: '',
    ref_link: '',
    tooltip_message: '',
  },
  {
    master_field_name: 'currency',
    label: '通貨',
    component_type: 'currency',
    ref_label: '',
    ref_link: '',
    tooltip_message: '',
  },
  {
    master_field_name: 'jpyrate',
    label: 'レート',
    component_type: 'alphanumeric',
    ref_label: '',
    ref_link: '',
    tooltip_message: '',
  },
];

export const getGetApInvoiceTransactionGeneralInputsMock = () => ({
  ap_invoice_transaction_general_inputs: [
    ...transactionGeneralInputs.map((input) => ({
      ...input,
      id: faker.number.int({ min: 1, max: 1000000 }),
      type: 'basic',
      is_visible: true,
      is_required: true,
      column_width: faker.number.int({ min: 1, max: 100 }),
      max_chars: faker.number.int({ min: 1, max: 100 }),
      min_chars: faker.number.int({ min: 1, max: 100 }),
      placeholder: faker.word.sample(),
      priority: faker.number.int({ min: 1, max: 100 }),
      ap_general_input_options: [],
      date_format_type: '',
    })),
    ...Array.from(
      { length: faker.number.int({ min: 1, max: 15 }) },
      (_, i) => i + 1
    ).map(() => ({
      id: faker.number.int({ min: 1, max: 1000000 }),
      label: faker.word.sample(),
      type: 'custom',
      component_type: faker.helpers.arrayElement([
        'text',
        'pulldown',
        'date',
        'alphanumeric',
      ]),
      ref_label: '',
      ref_link: '',
      is_visible: faker.datatype.boolean(),
      column_width: faker.number.int({ min: 1, max: 100 }),
      is_required: faker.datatype.boolean(),
      max_chars: faker.number.int({ min: 1, max: 100 }),
      min_chars: faker.number.int({ min: 1, max: 100 }),
      placeholder: faker.word.sample(),
      priority: faker.number.int({ min: 1, max: 100 }),
      ap_general_input_options: Array.from(
        { length: faker.number.int({ min: 1, max: 10 }) },
        (_, i) => i + 1
      ).map(() => ({
        id: faker.number.int({ min: 1, max: 1000000 }),
        label: faker.word.sample(),
      })),
      date_format_type: faker.helpers.arrayElement(['full_date', 'month_year']),
      tooltip_message: undefined,
    })),
  ],
});
